import React, { useState } from "react";
import styled from "styled-components";
import avatar from "../../images/avatar.png";
import { menuItems } from "../../utils/menuItems";

function Navigation({ active, setActive }) {
  return (
    <NavStyled>
      {/* <div className="user-container">
        <img src={avatar} alt="" />
        <div className="text">
          <h2>Huso Family</h2>
        </div>
      </div> */}
      <ul className="menu-items">
        {menuItems.map((item) => {
          return (
            <li key={item.id} onClick={() => setActive(item.id)} className={active === item.id ? "active" : ""}>
              {item.icon}
              <span>{item.title}</span>
            </li>
          );
        })}
      </ul>
    </NavStyled>
  );
}

const NavStyled = styled.nav`
  // padding: 2rem 0 0 1.5rem;
  // width: 374px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;
  .user-container {
    height: 100px;
    display: flex;
    align-items: center;
    gap: 1rem;
    img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      object-fit: cover;
      background: #fcf6f9;
      border: 2px solid #ffffff;
      padding: 0.2rem;
      box-shadow: 0px 1px 17px rgba(0, 0, 0, 0.06);
    }
    h2 {
      color: rgba(15, 16, 53, 1);
    }
    p {
      color: rgba(15, 16, 53, 0.6);
    }
  }

  .menu-items {
    flex: 1;
    display: flex;
    flex-direction: column;
    // @media (min-width: 768px) {
    //   flex-direction: column;
    // }
    li {
      display: grid;
      grid-template-columns: 40px auto;
      align-items: center;
      // margin: 0.6rem 0;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.4s ease-in-out;
      color: rgba(15, 16, 53, 0.6);
      padding: 1rem;
      position: relative;
      i {
        color: rgba(15, 16, 53, 0.6);
        font-size: 1.4rem;
        transition: all 0.4s ease-in-out;
      }
    }
  }

  .active {
    color: rgba(15, 16, 53, 1) !important;
    background: rgb(127, 199, 217);
    i {
      color: rgba(15, 16, 53, 1) !important;
    }
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 4px;
      height: 100%;
      background: #0F1035;
      border-radius: 0 10px 10px 0;
    }
  }
`;
export default Navigation;
